import React from "react";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import API from "@beardeddevops/react.api";

import APPCONFIG from "constants/Config";
import CollectionOverride from "components/CollectionOverride";
import {ListItemText, Tooltip} from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Access from "../../constants/Access";


class LocationsBoundBookDownloads extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Locations_Queues._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.anchorGen = false;
	};

	deleteDownload = (parent, id) => async () => {
		this.setState({loading: true});

		let bbQueueModel = new API.BuildClass(Types.Locations_Queues._name, API.RequestType.READ);

		bbQueueModel.object.pkey = id;
		bbQueueModel.parent = parent;

		try {
			await bbQueueModel.submit(null, API.RequestType.DELETE);
		} catch (e) {

		}

		this.setState({loading: false});
		this.props.reloadPage();
	}

	/**
	 *
	 * @param el
	 * @returns {(function(*): void)|*}
	 */
	handleOpen = (el) => event => {
		this.setState({
			[el]: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorGen: null,
		});
	};

	/**
	 *
	 * @param timeToDelete
	 */
	 handleDeleteAfterXTime = async (timeToDelete) => {
		let isPrimary = this.props.history.location.pathname.split('-').length - 1 !== 2;
		let bbToDelete = new API.BuildClass(Types.Locations_Bound_Books_Queues._name, 'POST_REMOVE_BOUND_BOOKS');
		bbToDelete.object.search = this.props.history.location.pathname.split("/").slice(2).join("/");
		bbToDelete.object.search_field = isPrimary;
		bbToDelete.object.days_to_delete = timeToDelete;
		await bbToDelete.submit(null, 'POST_REMOVE_BOUND_BOOKS');

		this.reloadTable();
		this.state.anchorGen = null;
	}



	// handleDeleteZipFile = async(e) => {
	// 	console.log('e', e, parseInt(e.currentTarget.id), e.currentTarget.getAttribute('binary_id'))
	// 	let zipDeleteModel = new API.BuildClass(Types.Locations_Bound_Books_Queues._name, 'DELETE_ZIP_FILE');
	// 	zipDeleteModel.object.pkey = parseInt(e.currentTarget.id);
	// 	zipDeleteModel.object.binary_id = e.currentTarget.getAttribute('binary_id');
	// 	let result = await zipDeleteModel.submit(null, 'DELETE_ZIP_FILE');
	//
	// 	this.reloadTable();
	// }

	render() {
		const {data, pages, limit, loading, anchorGen} = this.state;
		let {isAdmin, user} = this.props.rootState;
		const columns = [
			{
				Header: "Bound Book",
				id: "location_bound_books",
				/** @param {Locations_Queues_Object} obj */
				accessor: (obj) => {
					return obj.location_bound_books ? obj.location_bound_books.name : (obj.locations.bound_book || 'Primary')
				},
			},
			{
				Header: "Location",
				id: "location",
				/** @param {Locations_Queues_Object} obj */
				accessor: (obj) => {
					return obj.locations.name_display || obj.locations.name;
				},
			},
			{
				Header: "Date",
				id: "date",
				accessor: obj => {
					return obj.finished ? moment(obj.finished)
						.local()
						.format("MM/DD/YYYY") : obj.failed ? 'Failed' : 'Pending'
				}
			},
			{
				Header: "Processing Time",
				id: "processing",
				/**
				 * @param {Locations_Bound_Books_Queues_Object} obj
				 * @returns string
				 */
				accessor: obj => {
					if (obj.finished && !obj.failed) {
						let start = moment(obj.started);
						let finished = moment(obj.finished);
						let msDiff = finished.diff(start);
						let d = moment.duration(msDiff);
						let s = Math.floor(d.asHours()) + moment.utc(msDiff).format(":mm:ss");
						return s;
					}
					return '';
					// return obj.finished ? moment(obj.finished)
					// 	.local()
					// 	.format("MM/DD/YYYY") : obj.failed ? '' : ''
				}
			},
			{
				Header: "Status",
				id: "completed",
				/** @param {Locations_Queues_Object} obj */
				accessor: (obj) => {
					return obj.failed ? 'Failed' : (obj.completed ? 'Completed' : (obj.started ? 'Processing' : 'Pending'));
				},
			},
			{
				Header: "Legal/Filtered",
				id: "legal",
				/** @param {Locations_Queues_Object} obj */
				accessor: (obj) => {
					if (obj.search || obj.search_field || obj.entries || obj.date_start || obj.date_end || obj.sort || obj.sort_order) {
						return "Filtered";
					} else if (obj?.zip_file !== true) {
						return "Legal";
					} else {
						return 'ZIP'
					}
				},
			},
			{
				Header: "Search Field",
				id: "search_field",
				/** @param {Locations_Queues_Object} obj */
				accessor: obj => (obj.search_field + ' : ' + obj.search),
			},
			{
				Header: "Date Search",
				id: "date_start",
				/** @param {Locations_Queues_Object} obj */
				accessor: obj => {
					if (!obj.date_start) {
						return '';
					}
					let start = moment(obj.date_start).local().format("MM/DD/YYYY");
					let end = obj.date_end ? moment(obj.date_end).local().format("MM/DD/YYYY") : '';
					return 'Start: ' + start + (end ? (' End: ' + end) : '')
				},
			},
			{
				Header: "Entries",
				id: "entries",
				width: 100,
				/** @param {Locations_Queues_Object} obj */
				accessor: (obj) => {
					return obj.entries ? (obj.entries === 'O' ? 'Open' : 'Closed') : 'All';
				},
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							{props.original.completed && !props.original.failed &&
							<a
								target={'_blank'}
								href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/locations/${props.original.location_binary_id}-${props.original.location}/queues/${props.original._id}`}
							>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-download"}/></Button>
							</a>}
						</span>
					);
				}
			},
			// {
			// 	Header: "",
			// 	className: "button-cell",
			// 	filterable: false,
			// 	sortable: false,
			// 	width: 40,
			// 	Cell: props => {
			// 		return (
			// 			props.original.zip_file === true && props.original.completed ?
			// 				<Tooltip title={"Delete Pending"}>
			// 					<Button
			// 						id={props.original.pkey}
			// 						binary_id={props.original.binary_id}
			// 						color="danger"
			// 						size={"sm"}
			// 						block={true}
			// 						onClick={this.handleDeleteZipFile}>
			// 						<i className={"fa fa-times-circle"}/>
			// 					</Button>
			// 				</Tooltip> : ''
			// 		);
			// 	}
			// },
			...isAdmin || !user ? [{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					/** @type {Locations_Queues_Object} object */
					let object = props.original;
					let parent = object.location_binary_id + '-' + object.location;
					let id = object.binary_id + '-' + object.pkey;
					return (
						<span>
							{(object.processing || object.completed) &&
							<Button onClick={this.deleteDownload(parent, id)} color="danger" size={"sm"} block={true}>
								<i className={"fa fa-trash"}/></Button>
							}
						</span>
					);
				}
			}] : []
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Bound Books', "")}
							{this.props.rootState.userAccess <= Access.Manager &&  <>
								<Button
								// size={"sm"}
								color="danger"
								aria-owns={anchorGen ? 'anchorGen' : null}
								aria-haspopup="true"
								onClick={this.handleOpen('anchorGen')}
								style={{marginLeft: '500px'}}
							>
								<i className="fa fa-file-pdf-o"/>&nbsp;&nbsp;Delete Bound Books after X amount of days
							</Button>
							<Menu
								id="anchorGen"
								anchorEl={anchorGen}
								open={Boolean(anchorGen)}
								onClose={this.handleClose}
								getContentAnchorEl={null}
								anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
								transformOrigin={{horizontal: 'left', vertical: 'top'}}
							>
								<MenuItem onClick={() => this.handleDeleteAfterXTime('-7 days')}>
									<ListItemText inset primary="Delete all older than 7 days"/>
								</MenuItem>
								<MenuItem onClick={() => this.handleDeleteAfterXTime('-14 days')}>
									<ListItemText inset primary="Delete all older than 14 days"/>
								</MenuItem>
								<MenuItem onClick={() => this.handleDeleteAfterXTime('-31 days')}>
									<ListItemText inset primary="Delete all older than 31 days"/>
								</MenuItem>
							</Menu>
						</>}
							{this.renderHeaderRight("Bound Books", columns)}
						</div>
					</div>

					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>


					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(LocationsBoundBookDownloads);
